import { UsersView } from "@/features/users/components/UsersView"

export default function UsersPage() {
  return <UsersView />
}